import { Link, MenuItem, Select, Typography, useTheme } from "@mui/material";
import CoinAvatar from "components/CoinAvatar";
import { Col, Row } from "v2/components/base/Flex/ui";
import { Chain } from "chainConfigs";
import { Value } from "components/Value";
import { PercentageBlock } from "components/PercentageBrick";

const TradeRowItem = ({ tradeCall, navigateTo }: { tradeCall: any; navigateTo: () => void }) => {
  const { chain, symbol, imageUrl, marketCap, price, performance } = tradeCall;
  const theme = useTheme();

  return (
    <Link
      sx={{ all: "unset", cursor: "pointer", maxWidth: "100%", width: "calc(100% - 20px)" }}
      onClick={navigateTo}>
      <Row
        section="trade-row-item"
        type="bc"
        sx={{
          padding: "10px",
          border: `1px solid ${theme.palette.border.dark}`,
          background: theme.palette.surface.silver,
          borderRadius: theme.spacing(1.5),
          gap: "4px",
          maxWidth: "100%",
        }}
        fullWidth>
        <Row section="token-info" type="sc" sx={{ gap: "12px" }} fullWidth>
          <Col section="token-image" type="cc">
            <CoinAvatar
              style={{
                width: "32px",
                height: "32px",
              }}
              badgeStyle={{
                width: "16px",
                height: "16px",
              }}
              iconUri={imageUrl as string}
              chain={chain as Chain}
              size="sm"
            />
          </Col>
          <Col section="token-name" type="ss" textAlign="left">
            <Typography variant="subtitle" sx={{ marginTop: "-2px" }}>
              {symbol}
            </Typography>
            <Typography variant="body-sm" sx={{ marginTop: "-2px" }}>
              <Value variant="body-sm" value={marketCap} isPrice useFixedDecimals /> MKT CAP
            </Typography>
          </Col>
        </Row>
        <Col section="price-performance" type="ce" sx={{ gap: "4px", whiteSpace: "nowrap" }}>
          <Value variant="body-default" value={price} isPrice useFixedDecimals />
          <PercentageBlock percentage={performance} />
        </Col>
      </Row>
    </Link>
  );
};

export default TradeRowItem;
